import { useGetBackendVersion, VersionDTO } from "@bvhi/backend-api/apis";
import { Box, grey, Stack, Typography } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getAppConfig } from "../config/config";
import { BVHIRoute } from "../config/navigation";
import { toNarrowedTypeOrNull } from "../utils/ts";
import { RouterLink } from "./router-link";

interface LabelValueProps {
  label: string;
  value: string;
}

function LabelValue({ label, value }: LabelValueProps) {
  return (
    <Stack direction="row">
      <Typography color={grey[500]} fontWeight={500} pr={1} variant="body2">
        {label}
        {": "}
      </Typography>
      <Typography color={grey[500]} variant="body2">
        {value}
      </Typography>
    </Stack>
  );
}

interface Props {
  navigationConfig: BVHIRoute[];
}

export const BVHIFooter = ({ navigationConfig }: Props) => {
  const { t } = useTranslation(["routes"]);
  const { data: backendVersionResponse } = useGetBackendVersion();

  const navigationItems = useMemo(() => {
    return navigationConfig.filter((navigationEntry) => navigationEntry.shouldAppearInFooter && navigationEntry.label);
  }, [navigationConfig]);

  const shouldShowDevInfos = getAppConfig().env.stage !== "prod";

  const backendVersionInfo = toNarrowedTypeOrNull<VersionDTO>(backendVersionResponse?.data, "branch");

  return (
    <Box
      data-testid="bvhi-footer"
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        backgroundColor: (theme) => theme.palette.primary.main,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Stack justifyContent="space-evenly" sx={{ width: "100%" }}>
        <Stack direction="row" justifyContent="flex-end" pr={2} spacing={2} sx={{ width: "100%" }}>
          {navigationItems.map((navigationEntry) => {
            return (
              <RouterLink key={navigationEntry.id} color="white" to={navigationEntry.path} underline="hover" variant="body2">
                {navigationEntry.label ? t(navigationEntry.label) : ""}
              </RouterLink>
            );
          })}
        </Stack>

        {shouldShowDevInfos && (
          <Stack direction="row" justifyContent="flex-end" pr={2} spacing={2}>
            <LabelValue label="Stage" value={getAppConfig().env.stage} />
            <LabelValue label="Frontend" value={`${getAppConfig().env.branch}:${getAppConfig().env.version}`} />
            <LabelValue label="Backend" value={`${backendVersionInfo?.branch ?? "local"}:${backendVersionInfo?.version ?? -1}`} />
          </Stack>
        )}
      </Stack>

      {/* <Grid item xs={2} display="flex" justifyContent="flex-end" alignItems="center">
          <Typography
            onClick={() => {
              changeLanguage("de-DE");
            }}
            sx={{ cursor: "pointer" }}
            pr={1}
            color="white"
            variant="caption"
            fontWeight={i18n.language === "de-DE" ? 600 : undefined}
          >
            DE
          </Typography>
          <Typography
            onClick={() => {
              changeLanguage("en-US");
            }}
            sx={{ cursor: "pointer" }}
            color="white"
            variant="caption"
            fontWeight={i18n.language === "en-US" ? 600 : undefined}
          >
            EN
          </Typography>
        </Grid> */}
    </Box>
  );
};
